import SalesOrderSPKApi from './SalesOrderSPKApi'

export default SalesOrderSPKApi